"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faChevronDown = require("@fortawesome/pro-regular-svg-icons/faChevronDown");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Select = function Select(props) {
  var _props$label, _props$help;

  if (!(props !== null && props !== void 0 && props.defaultValue)) {
    props.options.unshift({
      label: 'Please select...',
      value: null,
      selected: true,
      disabled: true
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (props === null || props === void 0 ? void 0 : (_props$label = props.label) === null || _props$label === void 0 ? void 0 : _props$label.length) > 0 && (props === null || props === void 0 ? void 0 : props.type) !== 'hidden' && /*#__PURE__*/_react["default"].createElement("p", {
    className: "mb-[8px]"
  }, props.label, props.required && /*#__PURE__*/_react["default"].createElement("sup", {
    className: "text-brand-danger"
  }, "*")), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: props.name
  }, function (_ref) {
    var _props$options;

    var field = _ref.field,
        form = _ref.form;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "relative"
    }, /*#__PURE__*/_react["default"].createElement("select", {
      className: "appearance-none w-full py-[10px] px-[15px] rounded border border-brand-grey hover:border-brand-dark-grey text-[14px] \n                    focus:border-brand-black\n                    focus:box-shadow-[0_0_0_1px_#000]\n                    ".concat(props.help ? 'mb-[5px]' : 'mb-[15px]'),
      onChange: function onChange(_ref2) {
        var currentTarget = _ref2.currentTarget;
        form.setFieldValue(field.name, currentTarget.value);
      },
      defaultValue: props.defaultValue || props.options[0].value,
      disabled: form.isSubmitting || props.disabled
    }, (props === null || props === void 0 ? void 0 : (_props$options = props.options) === null || _props$options === void 0 ? void 0 : _props$options.length) > 0 && props.options.map(function (opt) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        key: "".concat(field.name, "_").concat(opt.value),
        value: opt.value,
        label: opt.label,
        disabled: opt.disabled === true,
        selected: opt.selected === true
      }, opt.label);
    })), /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faChevronDown.faChevronDown,
      className: "absolute right-[15px] top-[15px] text-sm"
    }));
  }), (props === null || props === void 0 ? void 0 : (_props$help = props.help) === null || _props$help === void 0 ? void 0 : _props$help.length) > 0 && (props === null || props === void 0 ? void 0 : props.type) !== 'hidden' && /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-brand-dark-grey text-[12px] mb-[15px] md:mb-[30px]"
  }, props.help));
};

exports.Select = Select;